import isFunction from "lodash/isFunction";
import { ExpandableBlock } from "@circle-react-uikit/ExpandableBlock";
import { useItemData } from "./ItemDataProvider";

export interface ButtonProps {
  children?: React.ReactNode;
  className?: string;
}

export const Button = ({ children, className }: ButtonProps) => {
  const { renderButton, onToggleItem } = useItemData();

  const onClickHandler = () => {
    isFunction(onToggleItem) && onToggleItem();
  };

  return (
    <ExpandableBlock.Button onClick={onClickHandler} className={className}>
      {children ? children : renderButton && renderButton()}
    </ExpandableBlock.Button>
  );
};
